export default __webpack_public_path__ + "static/media/services08.eefe35ed.jpg";